import React from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import Leaderboard from "../../components/Leaderboard/Leaderboard";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const TranscribeathonTestLeaderboard = () => {
  const query = useQuery();
  const eventId = query.get("eventId");

  return (
    <Box sx={{ p: 3 }}>
      <Leaderboard eventId={eventId} />
    </Box>
  );
};

export default TranscribeathonTestLeaderboard;
